export default { Visitor: 1, Agent: 2, Supervisor: 12 };
